import type { ChildGender } from '../types/profile'

/**
 * Adapta etiquetas con formato "Curioso/a" al género elegido.
 * En inglés las etiquetas no llevan "/a", así que la función las devuelve tal cual.
 */
export function adaptLabel(label: string, gender: ChildGender): string {
  if (!label.includes('/a')) return label
  return gender === 'daughter' ? label.replace(/o\/a/g, 'a') : label.replace(/\/a/g, '')
}
